import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import { Reveal, Eyebrow } from "@/components/motion";
import { PropertyMap } from "@/components/PropertyMap";
import { api } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

const MapPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useLang();

  useEffect(() => {
    api.get("/properties")
      .then((r) => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="map-page" className="pt-36 sm:pt-40 pb-24">
      <Seo
        title={t("seo.mapTitle")}
        siteName="ROMACASA"
        description={t("seo.mapDesc")}
      />
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Eyebrow>{t("map.eye")}</Eyebrow>
          <h1 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl font-medium leading-tight mt-4 mb-4">{t("map.title")}</h1>
          <p className="text-[#5B6670] font-light max-w-xl mb-10">{t("map.sub")}</p>
        </Reveal>
        {loading ? (
          <div className="py-24 text-center text-[#5B6670] font-light" data-testid="map-loading">{t("map.loading")}</div>
        ) : (
          <Reveal>
            <PropertyMap properties={items} height="70vh" />
            <p className="mt-4 font-mono-d text-xs text-[#5B6670]" data-testid="map-count">
              {items.filter((p) => p.lat && p.lng).length} {t("map.geo")}
            </p>
          </Reveal>
        )}
      </div>
    </div>
  );
};

export default MapPage;
